import createReducer from "utils/createReducer";
import { fromJS } from "immutable";
import { LinkTypes } from "actions/types";

export const defaultValue = fromJS({});

export const links = createReducer(defaultValue, {
  [LinkTypes.SET_LINKS](state, { payload }) {
    let newState = fromJS(payload);
    newState = newState.setIn(["isMultiGame"], payload.allowMultiGamePlay);
    return newState;
  },
  [LinkTypes.SET_MULTIGAME_ENABLED](state, { payload }) {
    let newState = state.setIn(["isMultiGame"], payload);
    return newState;
  },
  [LinkTypes.SET_GAME_PROVIDER_IMAGES_ENABLED](state, { payload }) {
    let newState = state.setIn(["preferences", "showProviderLogoOnGames"], payload.value);
    return newState;
  },
  [LinkTypes.PREFERENCES_FETCH_SUCCESS](state, { payload }) {
    let newState = state;
    if (payload.showProviderLogoOnGames !== undefined) {
      newState = newState.setIn(["isGameProviderImagesEnabled"], payload.showProviderLogoOnGames);
    }
    if (payload.allowMultiGamePlay !== undefined) {
      newState = newState.setIn(["isMultiGame"], payload.allowMultiGamePlay);
    }
    return newState;
  },
});
